var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconCleanUpComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-clean-up ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_81fe1c3e89__clip0_2738_73029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 15.3332C12.0502 15.3332 15.3334 12.0499 15.3334 7.99984C15.3334 3.94975 12.0502 0.666504 8.00008 0.666504C3.94999 0.666504 0.666748 3.94975 0.666748 7.99984C0.666748 12.0499 3.94999 15.3332 8.00008 15.3332ZM5.04893 10.244L7.29301 7.99988L5.04893 5.7558C4.91876 5.62562 4.91876 5.41457 5.04893 5.28439L5.28464 5.04869C5.41481 4.91852 5.62587 4.91852 5.75604 5.04869L8.00012 7.29277L10.2442 5.04869C10.3744 4.91852 10.5854 4.91852 10.7156 5.04869L10.9513 5.28439C11.0815 5.41457 11.0815 5.62562 10.9513 5.7558L8.70723 7.99988L10.9513 10.244C11.0815 10.3741 11.0815 10.5852 10.9513 10.7154L10.7156 10.9511C10.5854 11.0812 10.3744 11.0812 10.2442 10.9511L8.00012 8.70698L5.75604 10.9511C5.62587 11.0812 5.41481 11.0812 5.28464 10.9511L5.04893 10.7154C4.91876 10.5852 4.91876 10.3741 5.04893 10.244Z",
    fillOpacity: "1"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_81fe1c3e89__clip0_2738_73029"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))));
}
var IconCleanUp = /*#__PURE__*/React.forwardRef(IconCleanUpComponent);
export default IconCleanUp;